import classNames from 'classnames';
import type { ReactNode } from 'react';
import React from 'react';
import Button from '../../components/Button';
import * as styles from './TutorialModal.module.scss';

export type TutorialStep = {
  title: string;
  message: ReactNode;
  imageUrl: string;
};

interface TutorialModalProps {
  steps: TutorialStep[];
  stepIndex: number;
  additionalControls?: React.ReactNode;
  onPrimaryClick?: () => void;
  primaryButtonText?: string;
  onSecondaryClick?: () => void;
  secondaryButtonText?: string;
}

const TutorialModal = ({
  steps,
  stepIndex,
  additionalControls = null,
  onPrimaryClick,
  primaryButtonText,
  onSecondaryClick,
  secondaryButtonText,
}: TutorialModalProps) => {
  const step = steps[stepIndex];
  if (!step) return null;

  return (
    <div className={styles.container}>
      {[...new Set(steps.map((s) => s.imageUrl))].map((src) => (
        <img
          key={src}
          className={classNames(styles.headerImage, {
            [styles.isInvisible]: src !== step.imageUrl,
          })}
          src={src}
          alt=""
        />
      ))}
      <div className={styles.content}>
        <h4>{step.title}</h4>
        {step.message}
      </div>
      <div className={styles.controls}>
        <div className={styles.additionalControls}>{additionalControls}</div>
        <Button
          className={styles.secondaryButton}
          onClick={onSecondaryClick}
          variant="muted"
        >
          {secondaryButtonText}
        </Button>
        {onPrimaryClick && (
          <Button variant="secondary" onClick={onPrimaryClick}>
            {primaryButtonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default TutorialModal;
